import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ApronService } from '../../apron.service';

@Component({
  selector: 'up-pin-entry',
  templateUrl: './pin-entry.component.html',
  styleUrls: ['./pin-entry.component.scss']
})
export class PinEntryComponent {

  @Input() costCentreId: number | null = null;
  @Input() title = 'Enter Your PIN';

  @Output() pinValidated = new EventEmitter<number>();

  pin = '';
  isLoading = false;
  showPinVisible = false;
  errorMessage = '';

  constructor(private apronService: ApronService) {}

  onDigit(num: number) {
    if (this.pin.length < 6) {
      this.pin += num.toString();
      this.errorMessage = '';
    }
    if (this.pin.length === 6) {
      this.onSubmit();
    }
  }

  onClear() {
    this.pin = '';
    this.errorMessage = '';
  }

  onSubmit() {
    this.isLoading = true;
    if (!this.costCentreId && this.costCentreId !== 0) {
      this.errorMessage = 'Missing cost centre.';
      return;
    }

    const validatePOSPinRequest = {
      managerAccessPin: this.pin,
      costCentreId: this.costCentreId
    };

    this.apronService.validateManagerAccess(validatePOSPinRequest).subscribe(
      (response) => {
        this.isLoading = false;
        if (response.isManagementAccess) {
          const managerId = response.managerEmployeeId;
          localStorage.setItem('pin_auth', 'true');
          localStorage.setItem('manager_employee_id', managerId.toString());
          this.pinValidated.emit(managerId);
          this.pin = '';
          this.errorMessage = '';
        } else {
          this.errorMessage = 'Incorrect PIN.';
          this.pin = '';
        }
      },
      () => {
        this.isLoading = false;
        this.errorMessage = 'Incorrect PIN.';
        this.pin = '';
      }
    );
  }

  onToggleVisibility() {
    this.showPinVisible = !this.showPinVisible;
  }
}

